import React, { useEffect } from "react";
import CustomDialog from "../../sharedcomponents/dialog/dialog";
import ButtonContainer from "../../sharedcomponents/buttoncontainer/buttonContainer";
import
{
    Box,
    TextField, MenuItem
} from "@mui/material";
import { useState, createState } from '@hookstate/core';


const outfitState = createState({
    ticketType: '',
    cost: ''
});
const bowlData = [
    {
        id: 1,
        value: 'Upper Bowl'
    },
    {
        id: 2,
        value: 'Lower Bowl'
    }
]
const AddTicketSetting = (props) =>
{
    // const userInfo = useState(null);
    // const eventData = useState(null);
    const state = useState(outfitState);
    const [typeError, setTypeError] = React.useState('');
    const [costError, setCostError] = React.useState('');

    useEffect(() =>
    {
        if (props.ticketInfo != null)
        {
            state.set({
                cost: props.ticketInfo.ticketPrice,
                ticketType: props.ticketInfo.ticketType
            })
        } else
        {
            resetState()
        }
    }, []);
    const resetState = () =>
    {
        state.set({
            cost: '',
            ticketType: ''
        })
    }

    const renderDialogContent = () =>
    {
        return (<>
            <Box component="form" sx={{
                width: '100%',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    padding: 0,
                    flex: 1,
                }} >
                    <TextField
                        required
                        size="small"
                        fullWidth
                        label="Ticket Type"
                        select
                        error={typeError.length > 0 ? true : false}
                        helperText={typeError}
                        sx={{ flex: 0.5, pr: 1 }}
                        value={state.ticketType.get()}
                        onChange={(e) =>
                        {
                            state.ticketType.set(
                                e.target.value
                            );
                            setTypeError('')

                        }}
                    >
                        {bowlData &&
                            bowlData.map((option) => (
                                <MenuItem
                                    key={option.id}
                                    value={option.value}>
                                    {option.value}
                                </MenuItem>
                            ))}
                    </TextField>
                    <TextField
                        required
                        size="small"
                        id="outlined-required"
                        label="Cost"
                        type={'number'}
                        value={state.cost.get()}
                        onChange={(e) => { state.cost.set(e.target.value); setCostError('') }}
                        autoComplete="off"
                        error={costError.length > 0 ? true : false}
                        helperText={costError}
                        sx={{ flex: 0.5 }} />
                </Box>
            </Box>
        </>)
    }
    const renderDialogActions = () =>
    {
        return (
            <ButtonContainer
                showLoading={true}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.ticketInfo ? 'Update' : 'Create'}
            />
        );
    };

    const handleClick = () =>
    {
        console.log(state.get().ticketType);
        if (state.get().ticketType === '')
        {
            setTypeError('Please select ticket type')
        } else if (state.get().cost === '')
        {
            setCostError('Please enter the cost')
        } else
        {
            console.log('submit');
        }
    }

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}

        />

    )
}
export default AddTicketSetting;